import { render, staticRenderFns } from "./EtapaCnpj.vue?vue&type=template&id=08c9a5d1"
import script from "./EtapaCnpj.vue?vue&type=script&lang=js"
export * from "./EtapaCnpj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports